"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _xcrud = _interopRequireDefault(require("xcrud"));
var _config = _interopRequireDefault(require("xcrud/package/common/config"));
_config.default.set({
  input: {
    // size: 'mini'
  },
  select: {
    // size: 'mini'
  },
  colorPicker: {
    showAlpha: true
  },
  xform: {
    form: {
      labelWidth: 'auto'
      // size: 'mini'
    }
  }
});
var _default = exports.default = {
  components: {
    xForm: _xcrud.default.xForm
  }
};